import React, { useState } from "react";
import {
  Box,
  Button,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  Input,
  SimpleGrid,
  Stack,
  Text,
  Textarea,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import Card from "components/card/Card";
import { sendNotificationToAll } from "Api/apiService";

export default function NotificationsAdmin() {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [dataPayload, setDataPayload] = useState("");
  const [isSending, setIsSending] = useState(false);
  const toast = useToast();

  const textColor = useColorModeValue("navy.700", "white");
  const labelColor = useColorModeValue("secondaryGray.600", "whiteAlpha.700");

  const handleSend = async () => {
    if (!title.trim() || !body.trim()) {
      toast({
        title: "Title and message are required.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    let data = {};
    if (dataPayload.trim()) {
      try {
        data = JSON.parse(dataPayload);
      } catch (err) {
        toast({
          title: "Invalid JSON payload.",
          description: "Data payload must be valid JSON.",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
        return;
      }
    }

    setIsSending(true);
    try {
      const response = await sendNotificationToAll({
        title: title.trim(),
        body: body.trim(),
        data,
      });
      const { successCount, failureCount } = response?.data || {};
      toast({
        title: "Notification sent.",
        description:
          typeof successCount === "number"
            ? `Delivered: ${successCount}, Failed: ${failureCount}`
            : "Message queued to all devices.",
        status: "success",
        duration: 4000,
        isClosable: true,
      });
      setTitle("");
      setBody("");
      setDataPayload("");
    } catch (error) {
      console.error("Failed to send notification", error);
      toast({
        title: "Unable to send notification.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid columns={{ base: 1 }} spacing="20px">
        <Card p="24px">
          <Flex direction="column" gap="16px">
            <Text fontSize="22px" fontWeight="700" color={textColor}>
              Send Push Notification
            </Text>
            <Text fontSize="14px" color={labelColor}>
              Broadcast a notification to all registered devices.
            </Text>
            <Divider />
            <Stack spacing="14px">
              <FormControl>
                <FormLabel color={labelColor}>Title</FormLabel>
                <Input value={title} onChange={(e) => setTitle(e.target.value)} />
              </FormControl>
              <FormControl>
                <FormLabel color={labelColor}>Message</FormLabel>
                <Textarea
                  value={body}
                  onChange={(e) => setBody(e.target.value)}
                  rows={4}
                />
              </FormControl>
              <FormControl>
                <FormLabel color={labelColor}>
                  Data Payload (optional JSON)
                </FormLabel>
                <Textarea
                  value={dataPayload}
                  onChange={(e) => setDataPayload(e.target.value)}
                  placeholder='{"screen":"events"}'
                  rows={3}
                />
              </FormControl>
              <Button
                colorScheme="blue"
                onClick={handleSend}
                isLoading={isSending}
              >
                Send Notification
              </Button>
            </Stack>
          </Flex>
        </Card>
      </SimpleGrid>
    </Box>
  );
}
